import { useQuery } from "@tanstack/react-query";

import { api } from "../api/client";
import type { PhaseLine } from "../api/types";
import { useUi } from "../state/ui";

type LineName = PhaseLine["name"];

/** Langue du dossier affiché : celle du brouillon des Données initiales, sinon celle du dossier enregistré. */
export function useDossierLanguage(): "fr" | "en" {
  const exerciseId = useUi((s) => s.exerciseId);
  const draftLanguage = useUi((s) => s.draftLanguage);
  const { data: exercises = [] } = useQuery({ queryKey: ["exercises"], queryFn: api.exercises });
  if (draftLanguage) return draftLanguage;
  return exercises.find((e) => e.id === exerciseId)?.language === "en" ? "en" : "fr";
}

/** Nom affiché d'une ligne de coordination : L0 à L3, ou PL0 à PL3 (phase lines, terminologie OTAN) pour un
 *  dossier en anglais, comme dans l'ordre. L'identifiant (« L0 ») reste celui du serveur. */
export function lineLabel(name: string, language: "fr" | "en"): string {
  return language === "en" ? `P${name}` : name;
}

export function useLineLabel(): (name: LineName | string) => string {
  const language = useDossierLanguage();
  return (name) => lineLabel(name, language);
}
